import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUsuarioCreacionModel } from '../../../modelos/Usuario/modeloUsuario'; 

const ConfirmarCorreo = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { enviarCodigoVerificacion, confirmarCodigoYCrearUsuario } = useUsuarioCreacionModel();

    const datosPendientes = location.state?.datosPendientes;

    const [otp, setOtp] = useState('');
    const [cargando, setCargando] = useState(false);
    const [codigoEnviado, setCodigoEnviado] = useState(false); 

    useEffect(() => {
        if (!datosPendientes) {
            toast.error("Sesión inválida. Regístrate nuevamente.");
            navigate('/registro-cliente');
            return;
        }

    }, []);

    
    const enviarCodigoCorreo = async () => {
        await enviarCodigoVerificacion(datosPendientes.correoElectronico, 'email');
    };

    const verificarCodigo = async (e) => {
        e.preventDefault();

        if (otp.trim().length < 6) { 
            toast.warning("El código debe tener 6 dígitos.");
            return;
        }

        setCargando(true);

        const exito = await confirmarCodigoYCrearUsuario(
            datosPendientes.correoElectronico, 
            otp, 
            datosPendientes
        );

        console.log("exito",exito);

        if (exito) {
            navigate('/login');
        } else {
            setOtp(''); 
        }

        setCargando(false);

    };

    if(!datosPendientes) return null;

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center p-4">
            <div className="bg-white p-8 rounded-lg shadow-xl max-w-md w-full text-center">
                <div className="mb-6">
                    <span className="text-4xl" role="img" aria-label="email">📧</span>
                    <h2 className="text-2xl font-bold mt-4 text-gray-800">Verifica tu Correo</h2>
                    <p className="text-gray-600 mt-2 text-sm">
                        Hemos enviado un código de seguridad a: <br/>
                        <strong className="text-blue-600">{datosPendientes.correoElectronico}</strong>
                    </p>
                </div>

                <form onSubmit={verificarCodigo}>
                    <div className="mb-6">
                        <input
                            type="text"
                            placeholder="Ej: 123456"
                            className="w-full p-3 border border-gray-300 rounded text-center text-2xl tracking-widest font-mono focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all uppercase"
                            value={otp}
                            onChange={(e) => {
                                // Solo permitir números y limitar a 6 caracteres
                                const val = e.target.value.replace(/[^0-9]/g, '');
                                if (val.length <= 6) setOtp(val);
                            }}
                            autoFocus
                        />
                        <p className="text-xs text-gray-400 mt-2">Ingresa el código de 6 dígitos</p>
                    </div>

                    <button
                        type="submit"
                        disabled={cargando || otp.length < 6}
                        className={`w-full py-3 rounded-full text-white font-bold shadow-lg transition duration-200
                            ${(cargando || otp.length < 6) 
                                ? 'bg-gray-400 cursor-not-allowed' 
                                : 'bg-blue-600 hover:bg-blue-700 hover:-translate-y-0.5'}
                        `}
                    >
                        {cargando ? 'Verificando...' : 'Confirmar Registro'}
                    </button>
                </form>

                 <button 
                    onClick={enviarCodigoCorreo}
                    className="mt-6 text-sm text-blue-600 hover:text-blue-800 hover:underline font-medium transition"
                    type="button"
                >
                    ¿No recibiste el código? Reenviar ahora
                </button>
            </div>
        </div>
    );
};

export default ConfirmarCorreo;